function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
var FullScreen = function () {
    function FullScreen(player) {
        var _this = this;
        _classCallCheck(this, FullScreen);
        this.player = player;
        this.template = player.template;
        this.lastScrollPosition = {
            left: 0,
            top: 0
        };
        var docfullscreenchange = function docfullscreenchange() {
            var fullEle = document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            if (fullEle && fullEle !== _this.player.template.videoWrap) {
                return;
            }
            _this.player.resize();
            _this.player.set.setMode && _this.player.set.hide();
            if (fullEle) {
                _this.player.events.trigger('fullscreen');
            } else {
                utils.setScrollPosition(_this.lastScrollPosition);
                _this.player.events.trigger('fullscreen_cancel');
            }
        };
        var fullscreenchange = function fullscreenchange() {
            _this.player.resize();
            if (_this.isFullScreen()) {
                _this.player.events.trigger('fullscreen');
                _this.request();
            } else {
                _this.player.events.trigger('fullscreen_cancel');
                _this.cancel();
            }
        };
        if (/Firefox/.test(navigator.userAgent)) {
            document.addEventListener('mozfullscreenchange', docfullscreenchange);
            document.addEventListener('fullscreenchange', docfullscreenchange);
        } else {
            this.player.options.mode === 'web' && window.addEventListener('resize', fullscreenchange);
            this.player.template.videoWrap.addEventListener('fullscreenchange', fullscreenchange);
            this.player.template.videoWrap.addEventListener('webkitfullscreenchange', fullscreenchange);
            document.addEventListener('msfullscreenchange', docfullscreenchange);
            document.addEventListener('MSFullscreenChange', docfullscreenchange);
        }
    }
    _createClass(FullScreen, [
        {
            key: 'isFullScreen',
            value: function isFullScreen() {
                return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
            }
        },
        {
            key: 'getRequestMethods',
            value: function getRequestMethods(dom) {
                if (dom.requestFullscreen) {
                    return dom.requestFullscreen({ navigationUI: 'hide' });
                } else if (dom.mozRequestFullScreen) {
                    return dom.mozRequestFullScreen({ navigationUI: 'hide' });
                } else if (dom.webkitRequestFullscreen) {
                    return dom.webkitRequestFullscreen({ navigationUI: 'hide' });
                } else if (this.player.video.webkitEnterFullscreen) {
                    return this.player.video.webkitEnterFullscreen();
                } else if (this.player.video.webkitEnterFullScreen) {
                    return this.player.video.webkitEnterFullScreen();
                } else if (dom.msRequestFullscreen) {
                    return dom.msRequestFullscreen();
                }
            }
        },
        {
            key: 'getCancelMethods',
            value: function getCancelMethods() {
                if (document.cancelFullScreen) {
                    return document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    return document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    return document.webkitCancelFullScreen();
                } else if (document.webkitCancelFullscreen) {
                    return document.webkitCancelFullscreen();
                } else if (document.msCancelFullScreen) {
                    return document.msCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    return document.msExitFullscreen();
                }
            }
        },
        {
            key: 'request',
            value: function request() {
                var _this$getRequestMetho, _this$getRequestMetho2, _this2 = this;
                (_this$getRequestMetho = this.getRequestMethods(this.player.template.videoWrap)) === null || _this$getRequestMetho === void 0 ? void 0 : (_this$getRequestMetho2 = _this$getRequestMetho.then(function () {
                    screen.orientation.lock('landscape-primary').then(function () {
                    })['catch'](function (err) {
                        console.error(err);
                    })['finally'](function () {
                        _this2.handleFullscreen();
                    });
                })) === null || _this$getRequestMetho2 === void 0 ? void 0 : _this$getRequestMetho2['catch'](function (err) {
                    console.log(err);
                });
            }
        },
        {
            key: 'handleFullscreen',
            value: function handleFullscreen() {
                var _this3 = this;
                setTimeout(function () {
                    var _this3$player$templat = _this3.player.template, controller = _this3$player$templat.controller, controllerWrap = _this3$player$templat.controllerWrap, barWrap = _this3$player$templat.barWrap, videoMask = _this3$player$templat.videoMask, videoWrap = _this3$player$templat.videoWrap;
                    videoMask.classList.add('fullscreen');
                    videoWrap.classList.add('fullscreen');
                    controller.insertBefore(barWrap, controllerWrap);
                    _this3.player.danmaku.seek();
                    _this3.player.resize();
                    _this3.player.danmaku.danmakuTip.classList.remove('show');
                    _this3.player.danmaku.currentLockDanmaku && _this3.player.danmaku.currentLockDanmaku.classList.remove('lock');
                    _this3.player.controller.thumbnails && _this3.player.controller.thumbnails.resize(160, _this3.player.video.videoHeight / _this3.player.video.videoWidth * 160, _this3.player.template.bar.offsetWidth);
                }, 100);
            }
        },
        {
            key: 'cancel',
            value: function cancel() {
                screen.orientation.unlock();
                this.getCancelMethods();
                this.handleExitFullscreen();
            }
        },
        {
            key: 'handleExitFullscreen',
            value: function handleExitFullscreen() {
                var _this4 = this;
                var _this$player$template = this.player.template, controller = _this$player$template.controller, controllerWrap = _this$player$template.controllerWrap, barWrap = _this$player$template.barWrap, controllerLeft = _this$player$template.controllerLeft, browserFullButton = _this$player$template.browserFullButton, videoMask = _this$player$template.videoMask, videoWrap = _this$player$template.videoWrap;
                var setArr = [
                    'danmakuSet',
                    'playSet'
                ];
                setTimeout(function () {
                    videoMask.classList.remove('fullscreen');
                    videoWrap.classList.remove('fullscreen');
                    _this4.player.set.setMode && _this4.player.set.hide();
                    controllerLeft.insertBefore(barWrap, browserFullButton);
                    _this4.player.controller.isLocked = false;
                    _this4.player.danmaku.seek();
                    _this4.player.resize();
                    _this4.player.danmaku.danmakuTip.classList.remove('show');
                    _this4.player.danmaku.currentLockDanmaku && _this4.player.danmaku.currentLockDanmaku.classList.remove('lock');
                    _this4.player.controller.thumbnails && _this4.player.controller.thumbnails.resize(160, _this4.player.video.videoHeight / _this4.player.video.videoWidth * 160, _this4.player.template.bar.offsetWidth);
                }, 100);
            }
        }
    ]);
    return FullScreen;
}();
export default FullScreen;